import { Button, ButtonGroup, Stack } from '@mui/material';
import { ChevronRightIcon, Emoji } from '@silbo/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/logo.svg';
import { useUserAppContext } from '../contexts/UserAppContext';

export const Route = createFileRoute('/app-select')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (context.authenticationContext.isAuthenticated) {
      throw redirect({ to: '/' });
    }

    const { app } = context.userAppContext;
    if (app === 'porter') {
      throw redirect({ to: '/health-center-link' });
    }
    if (app === 'bed-manager' || app === 'cleaning-agent') {
      throw redirect({ to: '/login' });
    }
  },
});

const LOGO_HEIGHT = 50;

function RouteComponent() {
  const { t } = useTranslation('common');
  const navigate = Route.useNavigate();
  const { storeApp } = useUserAppContext();

  const handlePorter = () => {
    storeApp('porter');
    navigate({ to: '/health-center-link' });
  };

  const handleBedManager = () => {
    storeApp('bed-manager');
    navigate({ to: '/login' });
  };

  const handleCleaningAgent = () => {
    storeApp('cleaning-agent');
    navigate({ to: '/login' });
  };

  return (
    <Stack spacing={12} paddingX={12} justifyContent="center" height="100%">
      <Stack spacing={4} alignItems="center">
        <img src={logo} alt="logo" height={LOGO_HEIGHT} />
      </Stack>
      <Stack spacing={3} alignItems="center">
        <Stack spacing={3} maxWidth={600} width="100%">
          <ButtonGroup orientation="vertical" fullWidth variant="action">
            <Button
              onClick={handlePorter}
              startIcon={<Emoji name="manualWheelchair" size="normal" />}
              endIcon={<ChevronRightIcon color="secondary" />}
              sx={{ bgcolor: 'white' }}
            >
              {t('appSelect.iAmPorter')}
            </Button>
          </ButtonGroup>
          <ButtonGroup orientation="vertical" fullWidth variant="action">
            <Button
              startIcon={<Emoji name="stethoscope" size="normal" />}
              endIcon={<ChevronRightIcon color="secondary" />}
              onClick={handleBedManager}
              sx={{ bgcolor: 'white' }}
            >
              {t('appSelect.iAmDoctor')}
            </Button>
          </ButtonGroup>
          <ButtonGroup orientation="vertical" fullWidth variant="action">
            <Button
              startIcon={<Emoji name="bucket" size="normal" />}
              endIcon={<ChevronRightIcon color="secondary" />}
              onClick={handleCleaningAgent}
              sx={{ bgcolor: 'white' }}
            >
              {t('appSelect.iCleanBeds')}
            </Button>
          </ButtonGroup>
        </Stack>
      </Stack>
    </Stack>
  );
}
